import { z } from 'zod';
import { FINANCIAL_PRODUCT } from '../constants';
import { applicantMetadata, capacityToPayAgreement, generateSchema, repaymentAccountSource } from '../shared';
import { ApplicationStep } from '../types';
import { baseApplicationStep } from './baseApplication';

const submitApplicant = applicantMetadata.pick({
  type: true,
  status: true,
  operatorId: true,
});

const defaultSchema = {
  applicant: submitApplicant,
  primarySignatoryEmail: z.string().optional(),
  primarySignatoryName: z.string().optional(),
  secondarySignatoryEmail: z.string().optional(),
  secondarySignatoryName: z.string().optional(),
};

const flexSubmitApplication = {
  applicant: submitApplicant.merge(
    z.object({
      termsAndConditions: capacityToPayAgreement,
    }),
  ),
  payment: repaymentAccountSource,
};

const customSchemas = {
  [FINANCIAL_PRODUCT.FLEX]: flexSubmitApplication,
};

const submitApplication = generateSchema<typeof customSchemas, typeof defaultSchema>({
  customSchemas,
  defaultSchema,
});

export const updateApplicationSubmitSchema = submitApplication.and(baseApplicationStep).and(
  z.object({
    step: z.literal(ApplicationStep.SubmitApplication),
  }),
);
